<template>
  
  <div id="tell_wrapper" class="min-vh-100">
    <div class="position-relative">
      <div id="select_img_wrapper" class="container">
        <div class="d-flex flex-column align-items-center p-3 p-sm-5">
            <h2 tabindex="0" id="tell_header" class="guide-text-header px-3 py-1 mb-5">{{ $t(iKey('tell_section', 'tell_section', 'label')) }}</h2>
            <h3 class="explainer1 mb-4 text-center">{{ $t(iKey('tell_section', 'tell_section', 'cta')) }}</h3>
            <SVGArrow class="icon-arrow-down mb-4"></SVGArrow>
            <div class="grid w-100">
                <button 
                  :aria-label="$t(iKey('related_udhr_articles', i, 'illustration_desc'))"
                  class="item btn-reset bg-lazy" 
                  v-for="i in items" :key="i.id"
                  v-on:click="overlay=true; imgSelected=i" 
                  v-on:focus="overlay=false"
                  v-lazy:background-image="i.illustration.url_resized_square">
                </button>
            </div>
        </div>
      </div>
      <transition name="fade" v-on:after-enter="afterEnter">
        <div id="overlay" v-if="overlay" transition="fade" class="min-vh-100 position-absolute">
          
          <div class="container">
            
            <div class="row justify-content-center align-items-center min-vh-100">
              <div id="result-wrapper" class="col-9 col-md-6">
                <div tabindex="-1" ref="kudos" class="guide-text kudos position-absolute p-3" v-html="insertUserResponse($t(iKey('tell_section', 'tell_section', 'congrats')))"></div>
                <div ref="downloadable" id="result_downloadable" class="pr-5">
                  <img v-if="imgSelected" :src="imgSelected.illustration.url_resized_square" :alt="$t(iKey('related_udhr_articles', imgSelected, 'illustration_desc'))" class="img-fluid">
                  <div class="caption p-4" v-html="insertUserResponse($t(iKey('personal_strengths_section', 'personal_strengths', 'statement')))"></div>
                </div>
                
                <button id="download" class="btn-reset position-absolute" v-on:click="generateImg">
                  <SVGDownload role="button" class="icon-download"></SVGDownload>
                  <span class="sr-only">download</span>
                </button>
              </div>
            </div>

          </div>

          <button id="back" class="btn-reset position-absolute" v-on:click="overlay=false">
            <SVGArrow role="button" class="icon-arrow-back"></SVGArrow>
            <span class="guide-text pl-3 align-top">{{ $t(iKey('ui_labels', 'ui', 'back')) }}</span>
          </button>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import SVGArrow from '@/assets/icons/arrow-skinny.svg'
import SVGDownload from '@/assets/icons/download.svg'

export default {
  name: 'Tell',
  components: {
    SVGArrow,
    SVGDownload
  },
  props: [
    'items',
    'userName',
    'userCause',
    'userStrength'
  ],
  data: function(){
    return {
      overlay: false,
      //imgSrc: "",
      imgSelected: {},
      generatedImg: null
    }
  },
  methods: {
    insertUserResponse(string){
      var newString = ""
      newString = string.replace('{{name}}', this.$props.userName)
      newString = newString.replace('{{strength}}', '<em>' + this.$props.userStrength + '</em>')
      newString = newString.replace('{{cause}}', '<em>' + this.$props.userCause + '</em>')
      return newString
    },
    afterEnter() {
      this.$refs.kudos.focus();
    },
    async generateImg() {
      const el = this.$refs.downloadable;
      this.generatedImg = await this.$html2canvas(el).then(function(canvas){
          this.saveImg(canvas.toDataURL(), 'upstander.png');
      }.bind(this));
    },
    saveImg(uri, filename) {
      var link = document.createElement('a');

      if (typeof link.download === 'string') {

          link.href = uri;
          link.download = filename;

          //Firefox requires the link to be in the body
          document.body.appendChild(link);

          //simulate click
          link.click();

          //remove the link when done
          document.body.removeChild(link);

      } else {
          window.open(uri);
      }
    }
  },
  mounted() {
      // var dur = this.windowHeight
      // const scene = this.$scrollmagic.scene({
      //     triggerElement: '#tell_wrapper',
      //     triggerHook: 0,
      //     duration: dur
      // })
      // this.$scrollmagic.addScene(
      // scene
      //     .setPin('#tell_wrapper')
      //     //.addIndicators()
      // )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container-fluid {
    background-color: white;
}

.grid-parent{display:-ms-grid;}
.grid {
  display: grid;  
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 1em;
  grid-auto-flow: dense;
}
.grid > * {
  width: 100%;
  background-size: cover;
  background-position: center center;
}
.grid > *::before {
  content: "";
  display: inline-block;
  width: 1px;
  height: 0;
  padding-bottom: 100%;
}

.guide-text-header {
  background-color: #382e2b;
  color: #ffffff;
}
.icon-arrow-down {
  transform: rotate(90deg);
  width: 35px;
}
.icon-arrow-back {
  transform: rotate(180deg);
  width: 30px;
}
.icon-download {
  width: 60px;
}
#select_img_wrapper img {
  width: 146px;
  height: 146px;
  cursor: pointer;
}
#overlay {
  background-color: white;
  z-index: 1;
  top: 0;
  width: 100%;
}
#overlay .kudos {
  background-color: #ffd93d;
  top: 5%;
  left: 100px;
  
}
@media (min-width: 576px){
  #overlay .kudos {
    top: 20%;
    left: -100px;
    width: 350px;
  }
}
.caption {
  font-size: 12px;
}
@media (min-width: 576px){
  .caption {
    font-size: initial;
  }
}
#result_downloadable {
  background-color: #382e2b;
  color: white;
}
button#download {
  bottom: -80px;
  right: 0px;
}
button#back {
  left: 50px;
  top: 100px;
}
@media (min-width: 576px){
  button#download {
    bottom: 0;
    right: -100px;
  }
  button#back {
    left: 100px;
    top: 100px;
  }
}


.fade-transition {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0.0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
</style>
